import { useSelector } from 'react-redux';

import { selectCurrentCityDomain } from '~/src/store/selectors/city';

export const useIsMsk = () => {
    const domain = useSelector(selectCurrentCityDomain);
    return ['msk', 'msk-tc'].includes(domain);
};
